export class TipoIstanzaFascicoloDTO {
    id: string;
    nome: string;
    codice: string;
}